"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Tooltip_meta_1 = require("../Tooltip.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', Tooltip_meta_1.TOOLTIP_CATEGORY_KEY, Tooltip_meta_1.TOOLTIP_COMPONENT_KEY, ['tooltipChildrenButton']);